import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./style/productdetails.css";
// import image from "../assets/foto1.jpg";
function ProductDetails() {
  const location = useLocation();
  const [details, setDetails] = useState([]);

  useEffect(() => {
    setDetails(location.state.detailImage);
  }, [location]);
  return (
    <>
      <section className="cards-wrapper1">
        {details?.map((item,index) => {
          return (
            <div className="card-grid-space1" key={index}>
              <div className="num1">0{index + 1}</div>
              <a
                className="card1"
                href={item.url}
                style={{
                  backgroundImage:`url(${item.image})`,backgroundSize:"360px 200px",backgroundRepeat:"no-repeat"
                }}
                target="_blank"
                rel="noopener noreferrer"
              >
                <div>
                  <h1>{item.desc}</h1>
                  <p>{item.desc}</p>
                  <div className="date1">{new Date().getFullYear()}</div>
                  <div className="tags1">
                    <div className="tag1">React.js</div>
                  </div>
                </div>
              </a>
            </div>
          );
        })}
      </section>
    </>
  );
}

export default ProductDetails;
